module.exports = __webpack_public_path__ + "assets/images/tela_riscocardio.5378aa91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tela_riscocardio.png
// module id = 661
// module chunks = 1